export const MYSQL = 1;
export const MYSQL_VERSION_57 = 1;
export const MYSQL_VERSION_80 = 3;

export const LIST = [
  {
    id: MYSQL,
    name: "MySQL",
    defaultVersion: MYSQL_VERSION_57,
    versions: [MYSQL_VERSION_57, MYSQL_VERSION_80]
  }
];

export const LIST_VERSION_MYSQL = [
  {
    id: MYSQL_VERSION_57,
    name: "5.7",
    displayName: "MySQL 5.7"
  },
  {
    id: MYSQL_VERSION_80,
    name: "8.0",
    displayName: "MySQL 8.0"
  }
];

export const getVersionsForType = (typeId) => {
  const dbType = LIST.find(type => type.id === typeId);
  if (!dbType || !dbType.versions) return [];
  
  return dbType.versions.map(versionId => 
    LIST_VERSION_MYSQL.find(version => version.id === versionId)
  ).filter(Boolean);
};

export const getDefaultVersionForType = (typeId) => {
  const dbType = LIST.find(type => type.id === typeId);
  if (!dbType || !dbType.defaultVersion) return null;
  
  return LIST_VERSION_MYSQL.find(version => version.id === dbType.defaultVersion);
};

export const getVersionById = (versionId) => {
  return LIST_VERSION_MYSQL.find(version => version.id === versionId);
};

export const getTypeById = (typeId) => {
  return LIST.find(type => type.id === typeId);
};

export const getVersionName = (versionId) => {
  const version = getVersionById(versionId);
  return version ? version.name : '';
};

export const getVersionDisplayName = (versionId) => {
  const version = getVersionById(versionId);
  return version ? (version.displayName || version.name) : '';
};

export const mysqlId = () => MYSQL;

export const mysqlVersion57Id = () => MYSQL_VERSION_57;

export const mysqlVersion80Id = () => MYSQL_VERSION_80;

export const mysql57 = () => MYSQL_VERSION_57;

export const databaseVersions = () => LIST_VERSION_MYSQL;
